import HecRasHelper from "../Helpers/HecRasHelper";
import {useAppContext} from "../Context/ProjectContextV2";
import {useEffect, useState} from "react";

export default function ComparisonCSName({csName, csNameVal, csNameList = []}) {
    const {appContext, getSelectedHistory} = useAppContext()
    const [filter, setFilter] = useState({})

    const getStyle = (cs_name) => {
        const type = filter.type
        if(type === 'highlight') {
            return {
                color: HecRasHelper.inFilter({us: getSelectedHistory()?.page?.filter?.us, ds: getSelectedHistory()?.page?.filter?.ds, cs_name}) ? '#00a8ff' : ''
            }
        }
        else {
            return {
                color: ''
            }
        }
    }

    useEffect(() => {
        setFilter(getSelectedHistory()?.page?.filter || {})
    }, [getSelectedHistory()?.updateKey])

    if(csName) {
        return (
            <span className={'cross-section-name'} style={{...getStyle(csNameVal || csName)}}>
                {csName}
            </span>
        )
    }

    if(csNameList) {
        return csNameList.map((cs_name, idx) => (
            <>
                <span className={'cross-section-name'} style={{...getStyle(cs_name?.csNameVal || cs_name)}}>
                    {cs_name?.csName || cs_name}
                </span>
                {idx < csNameList.length-1 && (', ')}
            </>
        ))
    }
}